module.exports = __webpack_public_path__ + "static/media/edna27.5543167c.png";